import React from "react";
import { IconBase, type IconProps } from "./IconBase";
import auditLogsSVG from "images/icons/audit_logs.svg";

export const AuditLogsIcon = (props: IconProps) => {
  return <IconBase {...props} href={auditLogsSVG} />;
};
